<div class="d-flex justify-content-between w-100">
	<h5>Zadanie</h5>
	<i (click)="dialogRef.close()" role="button" class="fas fa-times fs-2"></i>
</div>

<form [formGroup]="taskForm">
	<div class="d-flex">
		<div class="w-75 d-flex flex-column">
			<div class="d-flex w-100">
				<div>
					<label class="me-2 w-60">Status:</label>
					<mat-form-field class="w-260" appearance="outline">
						<mat-select formControlName="status">
							<mat-option *ngFor="let item of status" [value]="item.id">
								{{ item.name }}
							</mat-option>
						</mat-select>
						<mat-error>Wybierz status</mat-error>
					</mat-form-field>
				</div>
				<div class="mx-2 pt-2">
					<p class="mb-0">
						Utworzone: {{ data.task?.createdBy.firstName }}
						{{ data.task?.createdBy.lastName }}
						{{ data.task?.createdAt.date }}
						<span *ngIf="data !== undefined">|</span>
						{{ data.task?.createdAt.time }}
					</p>
					<p class="mb-0">
						Ukończone: {{ data.task?.completedBy?.firstName }}
						{{ data.task?.completedBy?.lastName }}
						{{ data.task?.completed?.date }}
						<span *ngIf="data.task !== undefined && data.task.completed">|</span>
						{{ data.task?.completed?.time }}
					</p>
				</div>
			</div>
			<div>
				<label class="me-2 w-60">Rodzaj:</label>
				<mat-form-field class="w-8-10" appearance="outline">
					<mat-select formControlName="kind" multiple>
						<mat-option *ngFor="let item of kinds" [value]="item.id">
							{{ item.name }}
						</mat-option>
					</mat-select>
					<mat-error>Wybierz rodzaj</mat-error>
				</mat-form-field>
			</div>
			<div>
				<label class="me-2 w-60">Termin:</label>
				<mat-form-field class="w-25 me-2" appearance="outline">
					<mat-label>Wybierz date</mat-label>
					<input matInput formControlName="deadlineDate" [matDatepicker]="picker" [min]="minDate" />
					<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
					<mat-error>Uzupełnij date</mat-error>
				</mat-form-field>
				<mat-form-field class="w-25" appearance="outline">
					<mat-label>Wybierz godzinę</mat-label>
					<input
						matInput
						[(ngModel)]="currentTime"
						[format]="24"
						formControlName="deadlineTime"
						[ngxMatTimepicker]="pickerD"
						readonly
					/>
					<i matSuffix (click)="openPicker()" class="far fa-clock"></i>
					<mat-error>Uzupełnij godzinę</mat-error>
				</mat-form-field>
				<div class="ngx-mtp-box-bordered">
					<ngx-mat-timepicker appendToInput="false" #pickerD></ngx-mat-timepicker>
				</div>
			</div>
			<div class="d-flex align-items-start">
				<label class="me-2 mt-2 w-60">Treść:</label>
				<mat-form-field class="w-8-10" appearance="outline">
					<textarea formControlName="description" matInput></textarea>
					<mat-error>To pole nie może być puste</mat-error>
				</mat-form-field>
			</div>
		</div>
		<div class="w-25">
			<label class="me-2">Zadanie dla:</label>
			<mat-form-field class="w-100" appearance="outline">
				<mat-select formControlName="responsibleUser" multiple>
					<mat-form-field appearance="outline" class="w-100 h-100 px-3 pt-2">
						<mat-label>Wyszukaj</mat-label>
						<input matInput formControlName="usersSearch" />
					</mat-form-field>
					<mat-option *ngFor="let item of filteredUsers" [value]="item.id">
						{{ item.firstName }} {{ item.lastName }}
						<ng-container *ngIf="item.email">| {{ item.email }}</ng-container>
					</mat-option>
				</mat-select>
			</mat-form-field>
			<label class="me-2">Zadanie dla działu:</label>
			<mat-form-field class="w-100" appearance="outline">
				<mat-select formControlName="responsibleOrganization" multiple>
					<mat-option *ngFor="let item of departments" [value]="item.id">
						{{ item.name }}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="taskForm.errors?.userError"> Uzupełnij jedno z powyższych pól </mat-error>
			</mat-form-field>
		</div>
	</div>
	<app-note-list
		[task]="data.task.id"
		[view]="'summary'"
		[showHidden]="false"
		[editable]="data.editable"
		[tableId]="data.resId"
		[tableName]="TableName.RESERVATION"
		*ngIf="data.task !== undefined"
	></app-note-list>
	<div *ngIf="data.task === undefined" class="bg-notes m-2 rounded p-2 text-center">
		Notatki do zadania można dodawać tylko w już istniejących zadaniach
	</div>

	<button (click)="submit()" mat-raised-button class="float-end mt-2" color="primary">
		<span *ngIf="data.task === undefined && data.editable">Dodaj zadanie</span>
		<span *ngIf="data.task !== undefined && data.editable">Zapisz zmiany</span>
	</button>
</form>
